import { createSelector } from '@reduxjs/toolkit';
import { paymentSlice } from '@containers/Payment/slice';
export const selectPayment = createSelector((state) => state, (state) => state[paymentSlice.name]);
export const selectCouponDetails = createSelector(selectPayment, (state) => state.couponDetails);
export const selectPaymentDetails = createSelector(selectPayment, (state) => state.data);
export const selectRescheduledSlotData = createSelector(selectPayment, (state) => state.rescheduledSlotData);
export const selectLoading = createSelector(selectPayment, (state) => state.loading);
export const selectTransactionReportLoading = createSelector(selectPayment, (state) => state.transactionReport.isLoading);
export const selectTransactionReportStatus = createSelector(selectPayment, (state) => state.transactionReport.status);
